export default __webpack_public_path__ + "c79f6125c32916ee4a27003a1a354834.png";